import { CategoryHierarchy } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { Context } from '@vue-storefront/core';
import { LoadAllCategoriesProps } from '../../../types';

export async function loadAllCategories(
  context: Context,
  params: LoadAllCategoriesProps
): Promise<CategoryHierarchy[]> {
  const { $sapcc: { api: { getCatalogVersion } } } = context;

  const { categories = [] } = await getCatalogVersion(params);

  return categories;
}
